module.exports = __webpack_public_path__ + "img/unicorn.6670549.png";